import EcommerceViewModeEnum from "../../../models/EcommerceViewModeEnum";
import OwButton from "../../shared/OwButton/OwButton";
import "./EcommerceViewToggle.scss";

type Props = {
    viewMode: EcommerceViewModeEnum;
    onChange: (mode: EcommerceViewModeEnum) => void;
};

export const EcommerceViewToggle = (props: Props) => {
    const isCard = props.viewMode === EcommerceViewModeEnum.CARD;
    const isList = props.viewMode === EcommerceViewModeEnum.LIST;

    return (
        <div className={"EcommerceViewToggle"}>
            <div className={"btn-group"}>
                <OwButton
                    className={"btn-primary " + (isCard ? "active" : "")}
                    hoverTitle={"Card View"}
                    ariaLabel={"Card View"}
                    centerIconClass={"fad fa-th-large"}
                    fn={() => props.onChange(EcommerceViewModeEnum.CARD)}
                />
                <OwButton
                    className={"btn-primary " + (isList ? "active" : "")}
                    hoverTitle={"List View"}
                    ariaLabel={"List View"}
                    centerIconClass={"fad fa-list"}
                    fn={() => props.onChange(EcommerceViewModeEnum.LIST)}
                />
            </div>
        </div>
    );
};

export default EcommerceViewToggle;
